module.exports = __webpack_public_path__ + "static/media/feature-algorithms.2beb4b14.svg";